import { storePrefixPath } from '@/lib/namedRoutes'
import { withQuery } from '@/lib/routes/withQuery'

// Namespacing keeps call sites concise; this small helper object has negligible bundle impact.
export const storeRoutes = {
    /**
     * Store home. The Explore pill lands here.
     * Example: /
     */
    explore(): string {
        return '/'
    },

    /**
     * Visits category page.
     * Example: /store/visits
     */
    visits(): string {
        return `${storePrefixPath}/visits`
    },

    /**
     * Medications category page.
     * Example: /store/medications
     */
    medications(): string {
        return `${storePrefixPath}/medications`
    },

    /**
     * Labs category page.
     * Example: /store/labs
     */
    labs(): string {
        return `${storePrefixPath}/labs`
    },

    /**
     * Specialists category page.
     * Example: /store/specialists
     */
    specialists(): string {
        return `${storePrefixPath}/specialists`
    },

    /**
     * Storefront search results page.
     * Example: /store/search?query=metformin
     */
    search(query: string): string {
        return withQuery(`${storePrefixPath}/search`, { query })
    },
}
